export default "__VITE_ASSET__HWv5S8z7__"